export default __webpack_public_path__ + "static/media/tajir-logo.6d34a3af.png";